/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { DateInputRow } from '../../../../../javascript/shared/components/form';
import { FormHeader } from '../../react/form_header.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';
import { Checkbox } from '../../react/checkbox.jsx';
import { FormRow } from '../../react/form_row.jsx';
import React from 'react';
import moment from 'moment';
import _ from 'underscore';

function asOrdinal(number) {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const v = number % 100;
      const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];

      return `${number}${suffix}`;
    }

    function numberAsWord(number) {
      const numbers = [null, 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
      if ((number > 0) && (number <= 10)) {
        return numbers[number];
      } 
        return number;
      
    }

    function pluralize(count, string, plural_string = null) {
      if (Number(count) === 1) {
        return string;
      } 
        return plural_string || (`${string  }s`);
      
    }

// Component wrapping a form segment for the instance management
//
// This covers the date inputs as well as the instance list
export class ScheduleFormComponent extends React.Component {

      constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this._instancesChanged = this._instancesChanged.bind(this);
        this._calculateScheduleState = this._calculateScheduleState.bind(this);
        this._scheduleTypeChanged = this._scheduleTypeChanged.bind(this);
        this._inputChanged = this._inputChanged.bind(this);
        this.addInstances = this.addInstances.bind(this);
        this.validateState = this.validateState.bind(this);
        this.getRecurranceSummary = this.getRecurranceSummary.bind(this);
this.getRecurrenceSettings = this.getRecurrenceSettings.bind(this);

        // Create initial state
        this.state = {
          // Schedule type (automatic, manual)
          schedule_type: 'manual',
          // Send hour
          send_time: 0,
          // Repeat type
          repeat_type: 'once',
          // Repeat interval
          interval: 1,
          // Selected days of week (weekly recurrence)
          weekdays: [0, 1, 2, 3, 4, 5, 6],
          // Month repeat type (monthly recurrence)
          month_repeat_on: 'day_of_month',
          // End type for recurrence
          recurrence_end_type: 'date',
          // End date for recurrence
          recurrence_end_date: null,
          recurrence_end_date_invalid: false,
          // End count for recurrence
          recurrence_end_count: null,
          recurrence_end_count_invalid: false,
          // Current entry start date
          start_date: null,
          start_date_invalid: false,
          // Valid values entered, allowing addition of dates
          valid_entry: false,
          // Have entries of dates
          have_dates: this.props.eventInstances.count() > 0
        };

        // Apply initial schedule state
        this.state = _.assign(this.state, this._calculateScheduleState(props.scheduleData));
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.scheduleData !== this.props.scheduleData) {
          return this.setState(this._calculateScheduleState(nextProps.scheduleData), this.validateState);
        }
      }

      componentDidMount() {
        this.props.eventInstances.on('slzr:instance:add', this._instancesChanged);
        this.props.eventInstances.on('slzr:instance:change', this._instancesChanged);
        return this.props.eventInstances.on('slzr:instance:remove', this._instancesChanged);
      }

      componentWillUnmount() {
        this.props.eventInstances.removeListener('slzr:instance:add', this._instancesChanged);
        this.props.eventInstances.removeListener('slzr:instance:change', this._instancesChanged);
        return this.props.eventInstances.removeListener('slzr:instance:remove', this._instancesChanged);
      }

      _instancesChanged(instances) {
        return this.setState({have_dates: this.props.eventInstances.count() > 0});
      }

      // Convert the incoming schedule data props to proper internal state
      //
      // This sometimes means reversing the "macros" from it
      _calculateScheduleState(data) {
        const weekdays = (Array.from(data.weekdays.split(/,/)).map((i) => Number(i)));

        const state = {
          weekdays,
          interval: data.interval,
          send_time: Number(data.send_time),
          start_date: data.start_date,
          schedule_type: 'automatic'
        };

        switch (data.recurrence_type) {
          case 'weekly':
            if (_.isEqual(weekdays, [2, 4])) {
              state.repeat_type = 'weekdays_tth';
            } else if (_.isEqual(weekdays, [1, 3, 5])) {
              state.repeat_type = 'weekdays_mwf';
            } else if (_.isEqual(weekdays, [1, 2, 3, 4, 5])) {
              state.repeat_type = 'weekdays';
            } else {
              state.repeat_type = 'weekly';
            }
            break;
          case 'monthly':
            state.repeat_type = 'monthly_day_of_month';
            break;
          case 'monthly_day':
            state.repeat_type = 'monthly_day_of_week';
            break;
          case 'manual':
            state.repeat_type = 'manual';
            state.schedule_type = 'manual';
            break;
          default:
            state.repeat_type = data.recurrence_type;
        }

        if (data.recurrence_count > 0) {
          state.recurrence_end_type = 'count';
          state.recurrence_end_count = data.recurrence_count;
        } else if (data.end_date) {
          state.recurrence_end_type = 'date';
          state.recurrence_end_date = data.end_date;
        } else {
          state.recurrence_end_type = 'none';
        }


        return state;
      }

      // Handler for input changes
      _scheduleTypeChanged(event) {
        const state_updates = {};

        switch (event.target.value) {
          case 'manual':
            state_updates.schedule_type = 'manual';
            break;
          case 'automatic':
            state_updates.schedule_type = 'automatic';
            if (this.state.repeat_type === 'manual') { state_updates.repeat_type = 'once'; }
            break;
          default:
            console.error(`unknown schedule type: ${event.target.value}`);
        }

        return this.setState(state_updates);
      }

      _inputChanged(event, value) {
        switch (event.target.name) {
          case 'start_date':
            if ((value === 'error') || (value === 'blank')) {
              this.setState({start_date_invalid: true, start_date: null}, this.validateState);
            } else {
              this.setState({start_date_invalid: false, start_date: value}, this.validateState);
            }
            break;

          case 'send_time':
            this.setState({send_time: event.target.value}, this.validateState);
            break;

          case 'repeats':
            this.setState({repeat_type: event.target.value}, this.validateState);
            break;

          case 'interval':
            this.setState({interval: event.target.value}, this.validateState);
            break;

          case 'new_instance_recurrence_day':
            var new_weekdays = this.state.weekdays.splice(0);
            var weekday = Number(event.target.value);

            if (value) {
              // Chosen
              if (!(new_weekdays.indexOf(weekday) > -1)) { new_weekdays.push(weekday); }
            } else {
              // Removed
              const index = new_weekdays.indexOf(weekday);
              if (index > -1) {
                new_weekdays.splice(index, 1);
              }
            }

            this.setState({weekdays: new_weekdays.sort()}, this.validateState);
            break;

          case 'month_repeat_on':
            this.setState({month_repeat_on: event.target.value}, this.validateState);
            break;

          case 'recurrence_end_type':
            this.setState({recurrence_end_type: event.target.value}, this.validateState);
            break;

          case 'recurrence_end_date':
            if (value === 'error') {
              this.setState({recurrence_end_date_invalid: true, recurrence_end_date: null}, this.validateState);
            } else if (value === 'blank') {
              this.setState({recurrence_end_date_invalid: true, recurrence_end_date: null}, this.validateState);
            } else {
              this.setState({recurrence_end_date_invalid: false, recurrence_end_date: value}, this.validateState);
            }
            break;

          case 'recurrence_end_count':
            if (Number(event.target.value) > 0) {
              this.setState({recurrence_end_count: event.target.value, recurrence_end_count_invalid: false}, this.validateState);
            } else {
              this.setState({recurrence_end_count: event.target.value, recurrence_end_count_invalid: true}, this.validateState);
            }
            break;

          case 'new_instance_remove_future_dates':
            this.setState({remove_future_instances: value}, this.validateState);
            break;
        }

        if (typeof this.props.onInputChange === 'function') {
          this.props.onInputChange(event);
        }
        return event.stopPropagation();
      }

      // Handler for clicking of add button, this commits the changes to the instance list
      addInstances(event) {
        const settings = this.getRecurrenceSettings();
        this.props.eventInstances.addRecurring(settings);
        return (typeof this.props.onInstancesAdded === 'function' ? this.props.onInstancesAdded(event) : undefined);
      }

      // Validate the state and set the global validation flag appropriately
      validateState() {
        // Form validation checks
        const start_date_invalid = this.state.start_date_invalid || !this.state.start_date;
        const recurrence_end_count_invalid = this.state.recurrence_end_count_invalid || !this.state.recurrence_end_count;
        const recurrence_end_date_invalid = this.state.recurrence_end_date_invalid || !this.state.recurrence_end_date;

        const valid_start_date = !this.state.start_date_invalid && this.state.start_date;
        const valid_start_time = !this.state.start_time_invalid;
        const valid_end_time = !this.state.end_time_invalid;
        const valid_recurrence_end = (this.state.repeat_type === 'once') || (this.state.repeat_type === 'manual') ||
          ((this.state.recurrence_end_type === 'date') && !this.state.recurrence_end_date_invalid && this.state.recurrence_end_date) ||
          ((this.state.recurrence_end_type === 'count') && !this.state.recurrence_end_count_invalid && this.state.recurrence_end_count);

        return this.setState({
          valid_entry: valid_start_date && valid_start_time && valid_end_time && valid_recurrence_end,
          start_date_invalid
        });
      }


      render() {
        let day_of_month_text; let day_of_week_text;
        let i;
        const my = this;

        // Generate some of the option selections for large, programmtic lists

        // ...count list
        const interval_unit = (() => { switch (this.state.repeat_type) {
          case 'daily':
            return 'day';
          case 'weekdays': case 'weekdays_mwf': case 'weekdays_tth': case 'weekly':
            return 'week';
          case 'monthly_day_of_week': case 'monthly_day_of_month':
            return 'month';
          case 'yearly':
            return 'year';
          default:
            return '';
        } })();

        const interval_options = ((() => {
          const result = [];
          for (i = 1; i <= 30; i++) {
            result.push(<option key={i} value={i}>{i} {interval_unit}{i != 1 ? 's' : ''}</option>);
          }
          return result;
        })());

        // ...weekday option checkboxes
        const weekday_options = ((() => {
          const result1 = [];
          for (const [day, lbl] of ([
          [0, 'Sun'],
          [1, 'Mon'],
          [2, 'Tue'],
          [3, 'Wed'],
          [4, 'Thu'],
          [5, 'Fri'],
          [6, 'Sat']
        ])) {             result1.push(<td key={day}>
                                  <span className="day">{lbl}</span>
                                  <Checkbox value={day}
                                            checked={my.state.weekdays.indexOf(day) > -1}
                                            className="recur_day"
                                            data-instance="recurrence-day"
                                            onChange={my._inputChanged}
                                            name="new_instance_recurrence_day" />
                                </td>);
          }
          return result1;
        })());

        const send_time_options = ((() => {
          const result2 = [];
          for (i = 0; i <= 23; i++) {
            result2.push(<option key={i} value={i}>{moment().set({hours: i}).format('ha')}</option>);
          }
          return result2;
        })());

        // Calculate visibility options
        const is_recurring = this.state.repeat_type !== 'once';
        const summary_text = this.getRecurranceSummary();

        // Active date text
        const start = this.state.start_date ? moment(this.state.start_date) : moment();

        if (start.date() === start.daysInMonth()) {
          day_of_month_text = 'last';
        } else {
          day_of_month_text = start.format('Do');
        }

        const week_number = start.monthWeekByDay();
        if (week_number === 4) {
          day_of_week_text = `last ${start.format('dddd')}`;
        } else {
          day_of_week_text = `${['first', 'second', 'third', 'fourth'][week_number]  } ${  start.format('dddd')}`;
        }

        const recurrence_settings = this.getRecurrenceSettings();

        const schedule_form = this.state.schedule_type === 'automatic' ?
          <div>
            <DateInputRow label="Start Date"
                          name="start_date"
                          placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                          initialValue={this.state.start_date}
                          onChange={this._inputChanged}
                          showPreview={false}
                          showError={false}
                          required={true} />

            <FormRow title="Send Time">
              <select name="send_time"
                      ref="send_time"
                      value={this.state.send_time}
                      onChange={this._inputChanged}>
                {send_time_options}
              </select>
            </FormRow>

            {this.props.campaignKind != 'sms' && <FormRow title="Repeating">
              <select ref="repeats"
                      value={this.state.repeat_type}
                      onChange={this._inputChanged}
                      name="repeats">
                <option value="once">Never</option>
                <option value="daily">Every day</option>
                <option value="weekdays">Every weekday</option>
                <option value="weekdays_mwf">Every Mon, Wed, Fri</option>
                <option value="weekdays_tth">Every Tue, Thu</option>
                <option value="weekly">Every week</option>
                <option value="monthly_day_of_month">The {day_of_month_text} day</option>
                <option value="monthly_day_of_week">The {day_of_week_text}</option>
                <option value="yearly">Every year</option>
              </select>
            </FormRow>}

            {['daily', 'weekly', 'monthly_day_of_month', 'monthly_day_of_week', 'yearly'].indexOf(this.state.repeat_type) > -1 &&
              <FormRow title="Every">
                <select ref="interval"
                        value={this.state.interval}
                        onChange={this._inputChanged}
                        name="interval">
                  {interval_options}
                </select>
              </FormRow>}

            {this.state.repeat_type == 'weekly' && <FormRow title="Repeat on"
                     className="week_table_wrapper"
                     data-instance="recurrence-day-wrapper">
              <div className="week_table">
                <table border="0">
                  <tbody>
                    <tr>
                      {weekday_options}
                    </tr>
                  </tbody>
                </table>
              </div>
            </FormRow>}

            {is_recurring && <FormRow title="Repeating until" className="end-date-range">
              <select className="end-date-range-input"
                      name="recurrence_end_type"
                      value={this.state.recurrence_end_type}
                      onChange={this._inputChanged}>
                <option value="none">Stopped</option>
                <option value="date">A specific date has passed</option>
                <option value="count">A number of times have passed</option>
              </select>
            </FormRow>}

            {is_recurring && this.state.recurrence_end_type == 'date' &&
              <DateInputRow label=""
                            name="recurrence_end_date"
                            onChange={this._inputChanged}
                            placeholder="tomorrow"
                            initialValue={this.state.recurrence_end_date}
                            showPreview={false}
                            showError={false}
                            type="date"/>}

            {is_recurring && this.state.recurrence_end_type == 'count' &&
              <FormRow title="">
                <input type="text"
                       name="recurrence_end_count"
                       value={this.state.recurrence_end_count}
                       onChange={this._inputChanged}
                       placeholder="12" />
              </FormRow>}

            {summary_text && <FormRow title="Summary">
              <div className="schedule-summary">{summary_text}</div>
            </FormRow>}
          </div>

        :
          null;

        //;// Main UI
        return <div>
          <FormInputGroup>
            <FormRow title="Delivery">
              <select name="schedule_type"
                      ref="schedule_type"
                      value={this.state.schedule_type}
                      onChange={this._scheduleTypeChanged}>
                <option value="manual">Send manually</option>
                <option value="automatic">Send on a schedule</option>
              </select>
            </FormRow>

            {schedule_form}

          </FormInputGroup>

          {/* Fields to communicate the schedule back to the server */}
          <input type="hidden" name="bulletin_campaign[recurrence_type]" value={recurrence_settings.type} />
          <input type="hidden" name="bulletin_campaign[start_date]" value={recurrence_settings.start_date ? moment(recurrence_settings.start_date).format('YYYY-MM-DD') : ""} />
          <input type="hidden" name="bulletin_campaign[end_date]" value={recurrence_settings.recurrence_end_date ? moment(recurrence_settings.recurrence_end_date).format('YYYY-MM-DD') : ""} />
          <input type="hidden" name="bulletin_campaign[interval]" value={recurrence_settings.interval} />
          <input type="hidden" name="bulletin_campaign[recurrence_count]" value={recurrence_settings.recurrence_end_count || ''} />
          <input type="hidden" name="bulletin_campaign[weekdays]" value={recurrence_settings.weekdays.join(',')} />
          <input type="hidden" name="bulletin_campaign[send_time]" value={recurrence_settings.send_time} />

        </div>;
      }

      // Generate summary text
      //
      // DAILY/WEEKLY: Every [DOW1, DOW2 | Weekday | Weekend | Day]
      // MONTHLY: Every Nth day | Every third DOW
      // YEARLY: Every X years
      //
      // ending with:
      //  ; X times
      //  ; until Date
      getRecurranceSummary() {
        let summary_text;
        const settings = this.getRecurrenceSettings();

        // Return error message if part of the form is invalid
        if (this.state.start_date_invalid) { return "Invalid Start Date"; }

        // Show errors or hints for recurrence end
        if (this.state.repeat_type !== 'once') {
          // Recurrence end date
          if (this.state.recurrence_end_type === 'date') {
            if (this.state.recurrence_end_date_invalid) {
              return "Invalid Recurrence End Date";
            } else if (!this.state.recurrence_end_date) {
              return "Enter a recurrence end date above";
            }
          }

          // Recurrence end count
          if (this.state.recurrence_end_type === 'count') {
            if (this.state.recurrence_end_count_invalid) {
              return "Invalid Recurrence End Count";
            } else if (!this.state.recurrence_end_count) {
              return "Enter a recurrence end count above";
            }
          }
        }

        // Otherwise, build up the instance summary text
        let summary_text_date = [];
        if (settings.start_date) {
          if (settings.start_date) { summary_text_date.push(moment(settings.start_date).format('ddd, MMM D, YYYY')); }
          if (settings.send_time != null) { summary_text_date.push(moment().set({hours: settings.send_time}).format(', ha')); }
        }

        summary_text_date = summary_text_date.join('');

        if (this.state.repeat_type !== 'once') {
          let interval_label;
          const day_labels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

          summary_text = "repeating every ";
          if (settings.interval > 1) { summary_text += `${numberAsWord(settings.interval)  } `; }

          switch (settings.type) {
            case 'daily':
              interval_label = pluralize(settings.interval, 'day');
              break;
            case 'weekly':
              interval_label = pluralize(settings.interval, 'week');

              if (_.isEqual(settings.weekdays, [0, 1, 2, 3, 4, 5, 6])) {
                interval_label += ' on all days';
              } else if (_.isEqual(settings.weekdays, [0, 6])) {
                interval_label += ' on weekends';
              } else if (_.isEqual(settings.weekdays, [1, 2, 3, 4, 5])) {
                interval_label += ' on weekdays';
              } else {
                interval_label += ` on ${  (Array.from(settings.weekdays).map((day) => day_labels[day])).join(', ')}`;
              }
              break;
            case 'monthly': case 'monthly_day':
              interval_label = pluralize(settings.interval, 'month');

              // Show the date it recurs on (either date or weekday)
              if (settings.start_date) {
                const start_date = moment(settings.start_date);

                if (settings.repeat_on === 'day_of_month') {
                  if (start_date.date() === start_date.daysInMonth()) {
                    interval_label += " on the last day";
                  } else {
                    interval_label += ` on the ${start_date.format('Do')}`;
                  }
                } else if (settings.repeat_on === 'day_of_week') {
                  let week_number = start_date.monthWeekByDay();
                  if (week_number === 4) {
                    week_number = 'last';
                  } else {
                    week_number = ['first', 'second', 'third', 'fourth'][week_number];
                  }

                  interval_label += ` on the ${week_number} ${start_date.format('dddd')}`;
                }
              }
              break;

            case 'yearly':
              interval_label = pluralize(settings.interval, 'year');
              break;
          }

          summary_text += interval_label;

          // Range end date
          if ((this.state.recurrence_end_type === 'date') && this.state.recurrence_end_date) {
            summary_text += " until ";
            summary_text += moment(this.state.recurrence_end_date).format('MMM D, YYYY');
          } else if ((this.state.recurrence_end_type === 'count') && (this.state.recurrence_end_count > 0)) {
            summary_text += `, ${  this.state.recurrence_end_count  } times`;
          }
        } else {
          summary_text = null;
        }

        let result = _.compact([summary_text_date, summary_text]).join(', ');

        // Hint if we aren't showing an error or a summary
        if (!result) { result = 'Enter a start date above'; }

        return result;
      }

      // Return the current recurrence settings based on the user's selections
      //
      // This normalizes the weekday dropdown choices with the selected weekdays
      getRecurrenceSettings() {
        const result = {};

        let {
          weekdays
        } = this.state;
        result.interval = this.state.interval;

        switch (this.state.schedule_type) {
          case 'manual':
            result.type = 'manual';
            weekdays = [0, 1, 2, 3, 4, 5, 6];
            result.start_date = moment().format('YYYY-MM-DD');
            result.send_time = moment().get('hours');
            break;

          case 'automatic':
            switch (this.state.repeat_type) {
              case 'once':
                result.type = 'once';
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'daily':
                result.type = 'daily';
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'weekly':
                result.type = 'weekly';
                break;
              case 'monthly':
                result.type = 'monthly';
                result.repeat_on = this.state.month_repeat_on;
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'monthly_day_of_month':
                result.type = 'monthly';
                result.repeat_on = 'day_of_month';
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'monthly_day_of_week':
                result.type = 'monthly_day';
                result.repeat_on = 'day_of_week';
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'yearly':
                result.type = 'yearly';
                weekdays = [0, 1, 2, 3, 4, 5, 6];
                break;
              case 'weekdays':
                result.type = 'weekly';
                result.interval = 1;
                weekdays = [1, 2, 3, 4, 5];
                break;
              case 'weekdays_mwf':
                result.type = 'weekly';
                result.interval = 1;
                weekdays = [1, 3, 5];
                break;
              case 'weekdays_tth':
                result.type = 'weekly';
                result.interval = 1;
                weekdays = [2, 4];
                break;
            }

            result.start_date = this.state.start_date;
            result.send_time = this.state.send_time;
            break;
        }

        result.weekdays = weekdays.sort();

        switch (this.state.recurrence_end_type) {
          case 'count':
            result.recurrence_end_count = this.state.recurrence_end_count;
            result.recurrence_end_date = null;
            break;
          case 'date':
            result.recurrence_end_count = null;
            result.recurrence_end_date = this.state.recurrence_end_date;
            break;
          default:
            result.recurrence_end_count = null;
            result.recurrence_end_date = null;
        }


        return result;
      }
    }